import { axiosInstance } from "./api";

export const getAnaliticsPrice = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
  };

  const res = await axiosInstance.get("/analiticsPrice.get", { params });
  return res.data;
};

export const importAnaliticsPrice = async (props) => {
  const res = await axiosInstance.post("/analiticsPrice.import", props, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const downloadAnaliticsPrice = async (props) => {
  const res = await axiosInstance.post("/analiticsPrice.download", props, {
    responseType: "blob",
  });
  return res.data;
};

export const generateAnaliticsPrice = async () => {
  const res = await axiosInstance.post("/analiticsPrice.generate");
  return res.data;
};

export const getProgressAnaliticsPrice = async () => {
  const res = await axiosInstance.get("/analiticsPrice.getProgress");
  return res.data;
};

export const getAnaliticsStock = async (props) => {
  const params = {
    ...props,
    count: props.paginationCount,
    offset: props.paginationOffset,
    "sort[by]": props.sort?.by,
    "sort[dir]": props.sort?.dir,
  };

  const res = await axiosInstance.get("/api/v2/analiticsStock", { params });
  return res.data;
};

export const generateAnaliticsStock = async (props) => {
  const res = await axiosInstance.post("/api/v2/analiticsStock/generate", props);
  return res.data;
};

export const getProgress = async (props) => {
  const res = await axiosInstance.get("/api/v2/analiticsStock/getProgress", props);
  return res.data;
};

export const updateBestPrice = async (props) => {
  const res = await axiosInstance.post(
    "/analiticsStock.updateBestPrice",
    props
  );
  return res.data;
};

export const downloadAnaliticsStock = async (props) => {
  const res = await axiosInstance.post("/api/v2/analiticsStock/download", props, {
    responseType: "blob",
  });
  return res.data;
};

export const getNomenclatureInReserve = async (props) => {
  const res = await axiosInstance.get(
    "/api/v2/analiticsStock/getNomenclatureInReserve",
    { params: props }
  );
  return res.data;
};

export const getSalaryReport = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
    "sort[by]": props.sort?.by,
    "sort[dir]": props.sort?.dir,
  };

  const res = await axiosInstance.get("/salaryReport.get", { params });
  return res.data;
};

export const generateSalaryReport = async (props) => {
  const res = await axiosInstance.post("/salaryReport.generate", props);
  return res.data;
};

export const getProgressSalaryReport = async () => {
  const res = await axiosInstance.get("/salaryReport.getProgress");
  return res.data;
};

export const addDeduction = async (props) => {
  const res = await axiosInstance.post("/salaryReport.addDeduction", props);
  return res.data;
};

export const downloadSalaryReport = async (props) => {
  const res = await axiosInstance.post("/salaryReport.download", props, {
    responseType: "blob",
  });
  return res.data;
}

export const getAnaliticsSale = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
    "sort[by]": props.sort?.by,
    "sort[dir]": props.sort?.dir,
  };

  const res = await axiosInstance.get("/analiticsSale.get", { params });
  return res.data;
};

export const generateAnaliticsSale = async () => {
  const res = await axiosInstance.post("/analiticsSale.generate");
  return res.data;
};

export const getProgressAnaliticsSale = async () => {
  const res = await axiosInstance.get("/analiticsSale.getProgress");
  return res.data;
};

export const downloadAnaliticsSale = async (props) => {
  const res = await axiosInstance.post("/analiticsSale.download", props, {
    responseType: "blob",
  });
  return res.data;
};

// export const getLastUpdateAnaliticsSale = async () => {
//   const res = await axiosInstance.get("/analiticsSale.getDateLastUpdate");
//   return res.data;
// };

export const getAnaliticsReceivables = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
    "sort[by]": props.sort?.by,
    "sort[dir]": props.sort?.dir,
  };

  const res = await axiosInstance.get("/analiticsReceivables.get", { params });
  return res.data;
};

export const generateAnaliticsReceivables = async () => {
  const res = await axiosInstance.post("/analiticsReceivables.generate");
  return res.data;
};

export const getProgressAnaliticsReceivables = async () => {
  const res = await axiosInstance.get("/analiticsReceivables.getProgress");
  return res.data;
};

export const getLastUpdateAnaliticsReceivables = async () => {
  const res = await axiosInstance.get(
    "/analiticsReceivables.getDateLastUpdate"
  );
  return res.data;
};

export const downloadAnaliticsReceivables = async (props) => {
  const res = await axiosInstance.post(
    "/analiticsReceivables.download",
    props,
    {
      responseType: "blob",
    }
  );
  return res.data;
};

export const generateAnaliticsProvider = async () => {
  const res = await axiosInstance.post("/analiticsProvider.generate");
  return res.data;
};

export const getProgressAnaliticsProvider = async () => {
  const res = await axiosInstance.get("/analiticsProvider.getProgress");
  return res.data;
};

export const getAnaliticsProvider = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
    "sort[by]": props.sort?.by,
    "sort[dir]": props.sort?.dir,
  };

  const res = await axiosInstance.get("/analiticsProvider.get", { params });
  return res.data;
};

export const getStoreKeeperReport = async (props) => {
  const params = {
    ...props,
  };

  const res = await axiosInstance.get("/storeKeeperReport.get", { params });
  return res.data;
};

export const downloadAnaliticsProvider = async (props) => {
  const res = await axiosInstance.post(
    "/analiticsProvider.download",
    props,
    {
      responseType: "blob",
    }
  );
  return res.data;
};

export const getNextPayments = async (params) => {
  const res = await axiosInstance.get("api/v2/financeDashboard/nextPayments", { params });
  return res.data;
}
